export enum Enviroment {
  Production = 'production',
  Staging = 'staging',
  Develop = 'develop',
  Local = 'local',
}
